import { useState } from 'react';
import { Combobox, InputBase, useCombobox } from '@mantine/core';
import { FONT_OPTIONS } from '../types';

type Props = {
  label?: string;
  value: string;
  onChange: (value: string) => void;
};

export default function FontSelect({ label = 'Font', value, onChange }: Props) {
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  const [search, setSearch] = useState('');
  const [isEditing, setIsEditing] = useState(false);

  const filtered = FONT_OPTIONS.filter(font =>
    font.toLowerCase().includes(search.toLowerCase().trim()),
  );

  const options = filtered.map(font => (
    <Combobox.Option value={font} key={font}>
      <span style={{ fontFamily: font }}>{font}</span>
    </Combobox.Option>
  ));

  return (
    <Combobox
      store={combobox}
      onOptionSubmit={val => {
        onChange(val);
        setSearch('');
        setIsEditing(false);
        combobox.closeDropdown();
      }}
    >
      <Combobox.Target>
        <InputBase
          label={label}
          rightSection={<Combobox.Chevron />}
          rightSectionPointerEvents="none"
          value={isEditing ? search : value}
          onChange={event => {
            combobox.openDropdown();
            combobox.updateSelectedOptionIndex();
            setIsEditing(true);
            setSearch(event.currentTarget.value);
          }}
          onClick={() => combobox.openDropdown()}
          onFocus={() => {
            combobox.openDropdown();
            setIsEditing(true);
            setSearch('');
          }}
          onBlur={() => {
            combobox.closeDropdown();
            if (search.trim()) {
              onChange(search.trim());
            }
            setSearch('');
            setIsEditing(false);
          }}
          placeholder="Search or type font name"
        />
      </Combobox.Target>

      <Combobox.Dropdown>
        <Combobox.Options mah={300} style={{ overflowY: 'auto' }}>
          {options.length > 0 ? (
            options
          ) : (
            <Combobox.Empty>
              {search.trim() ? `Press Enter to use "${search.trim()}"` : 'No fonts found'}
            </Combobox.Empty>
          )}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
}
